// extracted by mini-css-extract-plugin
export default {"item":"empty-environment_item__cGHHP","captionContainer":"empty-environment_captionContainer__Xcuus","caption":"empty-environment_caption__JEBMT"};